<template>
  <div :class="{ 'has-logo': showLogo }" id="left-menu">
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        v-if="isLeftShow"
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        :default-openeds="defaultOpeneds"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in getCurrentMenu"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
      <div v-else class="scrollbar-wrapper-none">
        <div v-for="route in getCurrentMenu" :key="route.path">
          <div v-if="route.meta && !route.hidden">
            <!-- <el-tooltip  class="item" effect="dark" :content="route.meta.title" placement="right"> -->
            <div v-if="!route.children" class="wrapper-svg-icon" @click="jumpClick(route.path)">
              <svg-icon :icon-class="route.meta.icon" />
              <div
                class="iconText"
                v-if="route.meta.icon"
                :style="
                  route.path == $router.history.current.path ? 'color:#23253A' : 'color:#7B7C89'
                "
              >
                {{ $t(route.meta.titleKey || route.meta.title) }}
              </div>
            </div>
            <!-- </el-tooltip> -->
            <el-popover v-else placement="right-start" width="80" trigger="hover">
              <div class="rolling-slider">
                <div v-for="item in route.children" :key="item.path" @click="jumpClick(item.path)">
                  <div
                    v-if="item.meta"
                    class="wrapper-chilerdn"
                    :style="
                      item.path == $router.history.current.path ? 'background-color:#F4F5F9' : ''
                    "
                  >
                    {{ $t(item.meta.titleKey || item.meta.title) }}
                  </div>
                </div>
              </div>
              <div slot="reference" class="wrapper-svg-icon">
                <svg-icon :icon-class="route.meta.icon" />
                <div
                  class="iconText"
                  v-if="route.meta.icon"
                  :style="
                    $router.history.current.path.indexOf(route.path) > -1
                      ? 'color:#23253A'
                      : 'color:#7B7C89'
                  "
                >
                  {{ $t(route.meta.titleKey || route.meta.title) }}
                </div>
              </div>
            </el-popover>
          </div>
        </div>
      </div>
    </el-scrollbar>
    <help v-if="$i18n.locale === 'zh-CN' || $i18n.locale === 'zh-HK'"></help>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Logo from './Logo';
import SidebarItem from './SidebarItem';
import variables from '@/styles/variables.scss';
import Help from '@/components/help';
export default {
  components: { SidebarItem, Logo, Help },
  computed: {
    currentRoute() {
      return this.$router.history;
    },
    ...mapGetters(['authList', 'sidebar', 'hotelCode', 'hotelFrom']),
    isLeftShow() {
      return this.$store.state.app.isDisplayLeftMenu;
    },
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      if (path.includes('setting-index')) {
        return '/setting/system/setting-index';
      }
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    defaultOpeneds() {
      const route = this.$route;
      const { meta, path } = route;
      if (meta.activeMenu) {
        return [meta.activeMenu];
      }
      if (path.startsWith('/guest/order/list') || path.startsWith('/guest/roomOrder')) {
        return ['/guest/roomOrder', '/guest/order'];
      }
      return [this.$route.matched.slice(-2)[0].path];
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return false;
    },
    currentDomainConfig() {
      return this.$store.state.app.currentColorLogo || {};
    },
    hiddenSidebarMenuUrls() {
      return this.currentDomainConfig.hiddenSidebarMenuUrls || [];
    },
    getCurrentMenu() {
      let path = this.$route.matched && this.$route.matched[0] && this.$route.matched[0].path;
      const currentMenu = this.authList.find((item) => {
        return item.path == path;
      });
      const children = currentMenu.children ? currentMenu.children : [];
      return this.filterHiddenSidebarMenu(children);
    },
  },
  methods: {
    filterHiddenSidebarMenu(children) {
      if (!this.hiddenSidebarMenuUrls.length) {
        return children;
      }
      return children
        .filter((item) => {
          const menuUrl = item.path || item.url;
          return !this.hiddenSidebarMenuUrls.includes(menuUrl);
        })
        .map((item) => {
          if (item.children && item.children.length) {
            return {
              ...item,
              children: this.filterHiddenSidebarMenu(item.children),
            };
          }
          return item;
        });
    },
    jumpClick(path) {
      this.$router.push({
        path: path,
      });
    },
  },
};
</script>
<style lang="scss">
#left-menu {
  padding-top: 58px;

  .scrollbar-wrapper-none {
    color: #000;
  }

  .wrapper-svg-icon {
    height: 60px;
    text-align: center;
    font-size: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    cursor: pointer;

    .iconText {
      margin-top: 5px;
      width: 53px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .svg-icon {
      margin: 0px;
    }
  }

  .wrapper-svg-icon:hover {
    background-color: #f7f8fc;
    color: #7b7c89;
  }
}

.rolling-slider {
  max-height: 500px;
  overflow: auto;
}

.wrapper-chilerdn {
  cursor: pointer;
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #7b7c89;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
}

.wrapper-chilerdn:hover {
  background-color: #f7f8fc;
}
</style>
